import { render } from "./ban-ve-cho-chuyen-di-danh-cho-lai-xe.vue?vue&type=template&id=cb14925e&scoped=true"
import script from "./ban-ve-cho-chuyen-di-danh-cho-lai-xe.vue?vue&type=script&lang=js"
export * from "./ban-ve-cho-chuyen-di-danh-cho-lai-xe.vue?vue&type=script&lang=js"

import "./ban-ve-cho-chuyen-di-danh-cho-lai-xe.vue?vue&type=style&index=0&id=cb14925e&scoped=true&lang=css"
import "./ban-ve-cho-chuyen-di-danh-cho-lai-xe.vue?vue&type=style&index=1&id=cb14925e&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb14925e"]])

export default __exports__